import { config } from './config'
import firebase from "firebase/app"

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();